import React from "react";
import { CsvUploader } from "../../domain/bank/BankCsvUploader";
import GlobalFilter2 from "../filters/GlobalFilter2";
import { ClearAllButton } from "./ClearAllButton";
import { ColumnSelector } from "./ColumnSelector";
import { CookieSetter } from "./CookieSetter";
import { FilterSelector } from "./FilterSelector";
import { GetAll } from "./GetAll";
import { NewObjectButton } from "./NewObjectButton";
import { TriggerMatcher } from "./TriggerMatcher";
import { CustomsSync } from "./CustomsSync";

export function ActionPanel({
  setAllFilters,
  setGlobalFilter,
  diff,
  headerGroups,
  columns,
  newObjectLabel,
  dialogContent,
  refreshState,
  getBalancePartnerOptions,
  onBalancePartnerChange,
  csvOnChangeHandler,
  csvOnClickHandler,
  setActiveFilters,
  activeFilters,
  setActiveColumns,
  activeColumns,
  allColumns,
  tableName,
  cookieObjects,
  dialogSize,
  getAllData,
  triggerMatcher,
  syncInvoices,
}) {
  const clearAllFilter = (event) => {
    console.log("clearAll");
    setAllFilters([]);
    setGlobalFilter([]);
  };

  const getShownColumns = () => {
    const result = [];
    /* eslint-disable array-callback-return */
    headerGroups.map((headerGroup) =>
      headerGroup.headers.map((column) => {
        if (!column.columns) {
          if (typeof column.Header === "string") {
            const header =
              column.parent && typeof column.parent.Header === "string"
                ? column.parent.Header + " " + column.Header
                : column.Header;
            const obj = {
              value: column.id,
              label: header,
            };
            result.push(obj);
          }
        }
      })
    );
    /* eslint-enable array-callback-return */
    return result;
  };

  const getColumns = () => {
    const result = [];
    if (columns) {
      /* eslint-disable array-callback-return */
      columns.map((column) => {
        if (column.columns) {
          column.columns.map((nestedColumn) => {
            if (typeof nestedColumn.Header === "string") {
              const header =
                typeof column.Header === "string"
                  ? column.Header + " " + nestedColumn.Header
                  : nestedColumn.Header;
              const obj = {
                value: nestedColumn.id,
                label: header,
              };
              result.push(obj);
            }
          });
        } else {
          if (typeof column.Header === "string") {
            const header =
              column.parent && typeof column.parent.Header === "string"
                ? column.parent.Header + " " + column.Header
                : column.Header;
            const obj = {
              value: column.id,
              label: header,
            };
            result.push(obj);
          }
        }
      });
      /* eslint-enable array-callback-return */
    }
    return result;
  };

  return (
    <>
      <GlobalFilter2 setGlobalFilter={setGlobalFilter} diff={diff} />
      <span className="icons-span">
        {csvOnChangeHandler && (
          <CsvUploader
            onChangeHandler={csvOnChangeHandler}
            onClickHandler={csvOnClickHandler}
          />
        )}
        {triggerMatcher && <TriggerMatcher triggerMatcher={triggerMatcher} />}
        {newObjectLabel && (
          <NewObjectButton
            newObjectLabel={newObjectLabel}
            dialogContent={dialogContent}
            refreshState={refreshState}
            dialogSize={dialogSize}
          />
        )}
        <FilterSelector
          options={getShownColumns()}
          action={setActiveFilters}
          clearAll={clearAllFilter}
          activeFilters={activeFilters}
        />
        <ClearAllButton clearAllFilter={clearAllFilter} />
        {cookieObjects && (
          <CookieSetter cookieObjects={cookieObjects} tableName={tableName} />
        )}
        <GetAll getAllData={getAllData} />
        <ColumnSelector
          options={getColumns()}
          action={setActiveColumns}
          allColumns={allColumns}
          activeColumns={activeColumns}
        />
        {syncInvoices && (
          <CustomsSync
            syncInvoices={{ ...syncInvoices, refresh: refreshState }}
          />
        )}
      </span>
    </>
  );
}
